import { useContext } from "react";
import { Tag, Typography } from "antd";
import { UserOutlined, CheckCircleOutlined, ClockCircleOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";

import { IMessageUser } from "../../../interfaces";
import { formatCpf } from "../../../../../utils/Masks";
import { ThemeContext } from "../../../../../contexts/ThemeContext";

const { Text } = Typography;

interface IProps {
    appUser: IMessageUser;
    filters: {
        name: string;
        cpf: string;
    };
}

export default function AppUserRow({ appUser, filters }: IProps) {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === "dark";

    return (
        <div
            style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "10px 14px",
                borderRadius: 8,
                backgroundColor: isDark ? "#1f1f1f" : "#f8fafc",
                border: `1px solid ${isDark ? "#303030" : "#e2e8f0"}`,
                transition: "all 0.2s ease",
            }}
        >
            <div style={{ display: "flex", alignItems: "center", gap: 10, minWidth: 0 }}>
                <div
                    style={{
                        width: 32,
                        height: 32,
                        borderRadius: "50%",
                        backgroundColor: isDark ? "rgba(22, 119, 255, 0.15)" : "#e6f4ff",
                        color: "#1677ff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 14,
                        flexShrink: 0,
                    }}
                >
                    <UserOutlined />
                </div>

                <div style={{ display: "flex", flexDirection: "column", gap: 2, minWidth: 0 }}>
                    <Text
                        strong
                        style={{
                            fontSize: 13,
                            color: isDark ? "#f0f0f0" : "#1e293b",
                            lineHeight: 1.3,
                        }}
                    >
                        <Highlighter
                            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
                            searchWords={[filters.name]}
                            autoEscape
                            textToHighlight={appUser.name || "Sem Nome"}
                        />
                    </Text>
                    <Text
                        type="secondary"
                        style={{
                            fontSize: 12,
                            color: isDark ? "#94a3b8" : "#64748b",
                        }}
                    >
                        <Highlighter
                            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
                            searchWords={[filters.cpf, formatCpf(filters.cpf)]}
                            autoEscape
                            textToHighlight={formatCpf(appUser.cpf)}
                        />
                    </Text>
                </div>
            </div>

            <Tag
                icon={appUser.read ? <CheckCircleOutlined /> : <ClockCircleOutlined />}
                color={appUser.read ? "success" : "default"}
                style={{
                    margin: 0,
                    borderRadius: 4,
                    fontWeight: 500,
                    fontSize: 11,
                    padding: "2px 8px",
                }}
            >
                {appUser.read ? "Lido" : "Não lido"}
            </Tag>
        </div>
    );
}